import { ELabelTagType } from '@pu/mpp-ui/components/label-tag';
import { ENavigationFormError, ENavigationStatus } from 'core/model/enums/navigation.enum';

export const NAVIGATION_TREE_STATUS_TAGS: Record<
  number,
  {
    color: ELabelTagType;
    highlight: boolean;
    text: string;
  }
> = {
  [ENavigationStatus.PUBLISHED]: { color: ELabelTagType.POSITIVE, highlight: false, text: 'Publicado' },
  [ENavigationStatus.PENDING_PUBLICATION]: {
    color: ELabelTagType.WARNING,
    highlight: true,
    text: 'Publicación pendiente',
  },
  [ENavigationStatus.INCOMPLETE_EDITION]: { color: ELabelTagType.WARNING, highlight: true, text: 'Incompleto' },
  [ENavigationStatus.EMPTY]: { color: ELabelTagType.WARNING, highlight: true, text: 'Incompleto' },
  [ENavigationStatus.DEFAULT]: { color: ELabelTagType.NEUTRAL, highlight: false, text: 'Genérico' },
};

export const NAVIGATION_FORM_ERRORS = [ENavigationFormError.familyOrderFile];
export const SUBITEM_FORM_ERRORS = [ENavigationFormError.productIds];
